module.exports = __webpack_public_path__ + "img/2.25b25023.jpg";